import type { CalculatedMaterial } from "./types";

// Only the three native 621/5 gold, 2×2 cross variants. Geometry comes from
// calculated pieces, not the product dimensions or a guessed perimeter.
export function decorativeCross(materials: CalculatedMaterial[], location: string) {
  const widths: Record<string, number> = { "KPG/720": 8, "SPGF 1808 GOLD": 18, SPGF2608GOLD: 26 };
  const bar = materials.find(m => m.visualPart === "decorative-bar" && m.locations?.includes(location));
  const glass = materials.find(m => m.visualPart === "glass" && m.locations?.includes(location))?.pieces?.find(p => p.location === location);
  const widthMm = bar && widths[bar.code];
  const pieces = bar?.pieces?.filter(p => p.location === location) ?? [];
  if (!widthMm || !glass || !glass.widthMm || pieces.length !== 4 ||
      ["Верх", "Право", "Низ", "Лево"].some(side => pieces.filter(p => p.side === side).length !== 1)) return null;
  return { widthMm, glassWidthMm: glass.lengthMm, glassHeightMm: glass.widthMm, pieces };
}
